import { css } from '@emotion/react'
import theme from '../theme'

export default css`
    [class^='ant-table'],
    .ant-table-wrapper .ant-table {
        font-size: 14px;
    }

    .ant-table-filter-dropdown {
        position: relative;
        overflow: visible !important;
    }

    .ant-table-row {
        background-color: ${theme.colors.background.main};
    }

    .ant-table-wrapper .ant-table-filter-trigger {
        color: ${theme.colors.disabled.light};
    }

    .ant-table-wrapper.readonly-array .ant-table-cell {
        background: #35313a;
        color: ${theme.colors.disabled.light};
    }

    .ant-table-wrapper.readonly-array .ant-table-cell .ant-typography {
        color: ${theme.colors.disabled.light};
    }
`
